import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { ServiceEx } from '../../../../../../../models/ServicePresets';
import { TextButton, TextButtonClassNames } from '../../../../../../commons/buttons/TextButton';
import { modalSlice } from '../../../../../../../store/reducers/ModalSlice';
import { ModalVariants } from '../../../../../../../models/Common';
import { ReactComponent as CheckIcon } from '../../../../../../../assets/images/ArrowSaveEmail.svg';

interface ClientExSrvProps {
  serviceEx: ServiceEx;
  isDisabled: boolean;
}

const ClientExSrv: FC<ClientExSrvProps> = ({ serviceEx: { Price, Name, IsConnected }, isDisabled }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { openModal } = modalSlice.actions;
  const handleConnect = () => {
    dispatch(openModal({ modalVariants: ModalVariants.GetHelp, content: { service: Name } }));
  };
  return (
    <div className="service-card__info-container__info__additional">
      {Name}
      {IsConnected ? ` (${Price} ${t('services.uahPerMonth')})` : null}:&nbsp;
      {IsConnected ? (
        <span className="active connected-extra">
          {t('common.connected')}&nbsp; <CheckIcon className="icon-check" />
        </span>
      ) : (
        <TextButton
          label={`${t('buttons.addFor')} ${Price} ${t('services.uahPerMonth')}`}
          handleClick={handleConnect}
          className={TextButtonClassNames.PrimaryActive}
          isDisabled={isDisabled}
        />
      )}
    </div>
  );
};

export default ClientExSrv;
